import { useState, useEffect } from 'react'
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AuthProvider, useAuth } from './contexts/AuthContext'
import Navigation from './components/Navigation'
import AgeVerificationModal from './components/AgeVerificationModal'
import ComingSoonLanding from './components/ComingSoonLanding'
import Home from './pages/Home'
import VendorDirectory from './pages/VendorDirectory'
import VendorVerification from './pages/VendorVerification'
import Mission from './pages/Mission'
import Community from './pages/Community'
import Social from './pages/Social'
import CreateThread from './pages/CreateThread'
import ThreadView from './pages/ThreadView'
import Messages from './pages/Messages'
import Notifications from './pages/Notifications'
import UserProfile from './pages/UserProfile'
import Reviews from './pages/Reviews'
import VendorDashboard from './pages/VendorDashboard'
import VendorProfile from './pages/VendorProfile'
import AdminDashboard from './pages/AdminDashboard'
import StaffDashboard from './pages/StaffDashboard'
import ProductDetail from './pages/ProductDetail'
import EnhancedSearchPage from './pages/EnhancedSearchPage'
import LabVerificationPage from './pages/LabVerificationPage'
import ReferralDashboard from './pages/ReferralDashboard'
import RewardsProgram from './pages/RewardsProgram'
import Friends from './pages/Friends'
import VendorLounge from './pages/VendorLounge'
import PrivacyPolicyPage from './pages/PrivacyPolicyPage'
import TermsOfServicePage from './pages/TermsOfServicePage'
import LegalDisclaimer from './pages/LegalDisclaimer'
import AnalyticsPage from './pages/AnalyticsPage'
import TrustedTesterProgramPage from './pages/TrustedTesterProgramPage'
import VendorAccountabilityPage from './pages/VendorAccountabilityPage'
import QualityCompliancePage from './pages/QualityCompliancePage'
import ReviewIntegrityPage from './pages/ReviewIntegrityPage'
import AdminToolsOverview from './pages/AdminToolsOverview'
import VendorBenefitsMailer from './pages/VendorBenefitsMailer'
import InviteManager from './pages/InviteManager'
import WaitlistManager from './pages/WaitlistManager'

const TaperTrackerRedirect = () => {
  useEffect(() => {
    window.location.href = '/taper-tracker/index.html'
  }, [])
  return <div>Redirecting to Taper Tracker...</div>
}

function AppContent() {
  const { user, isAgeVerified, isLoading } = useAuth()

  const handleTesterLogin = () => {
    window.location.href = '/taper-tracker/index.html'
  }

  // Show loading screen while authentication is being checked
  if (isLoading) {
    return (
      <div className="loading-screen">
        <div className="loading-content">
          <h2>Loading...</h2>
          <p>Please wait while we set up your experience</p>
        </div>
      </div>
    )
  }

  // Debug logging (remove in production)
  console.log('App render - User:', user ? `${user.username} (${user.role})` : 'null', 'isLoading:', isLoading)
  console.log('Access check - Admin access:', user?.role === 'admin')

  return (
    <Router>
      <div className="app">
        <Routes>
          {/* Public routes */}
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          
          {/* Protected routes - admin only for now */}
          <Route path="/*" element={
            !user || !user.id || user.role !== 'admin' ? (
              <ComingSoonLanding onTesterLogin={handleTesterLogin} />
            ) : (
              <>
                <AgeVerificationModal isOpen={!isAgeVerified} />
                {isAgeVerified && (
                  <>
                    <Navigation />
                    <main className="main-content">
                      <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/vendors" element={<VendorDirectory />} />
                <Route path="/vendor/:vendorId" element={<VendorProfile />} />
                <Route path="/vendor/:vendorId/product/:productId" element={<ProductDetail />} />
                <Route path="/search" element={<EnhancedSearchPage />} />
                <Route path="/lab-verification" element={<LabVerificationPage />} />
                <Route path="/verification" element={<VendorVerification />} />
                <Route path="/mission" element={<Mission />} />
                <Route path="/community" element={<Community />} />
                <Route path="/social" element={<Social />} />
                <Route path="/community/create-thread" element={<CreateThread />} />
                <Route path="/community/thread/:threadId" element={<ThreadView />} />
                <Route path="/messages" element={<Messages />} />
                <Route path="/notifications" element={<Notifications />} />
                <Route path="/profile/:userId" element={<UserProfile />} />
                <Route path="/profile" element={<UserProfile />} />
                <Route path="/reviews" element={<Reviews />} />
                <Route path="/vendor-dashboard" element={<VendorDashboard />} />
                <Route path="/admin" element={<AdminDashboard />} />
                <Route path="/admin-dashboard" element={<AdminDashboard />} />
                <Route path="/staff-dashboard" element={<StaffDashboard />} />
                <Route path="/referrals" element={<ReferralDashboard />} />
                <Route path="/rewards" element={<RewardsProgram />} />
                <Route path="/friends" element={<Friends />} />
                <Route path="/vendor-lounge" element={<VendorLounge />} />
                <Route path="/legal-disclaimer" element={<LegalDisclaimer />} />
                <Route path="/analytics" element={<AnalyticsPage />} />
                <Route path="/trusted-tester-application" element={<TrustedTesterProgramPage />} />
                <Route path="/vendor-accountability" element={<VendorAccountabilityPage />} />
                <Route path="/quality-compliance" element={<QualityCompliancePage />} />
                <Route path="/review-integrity" element={<ReviewIntegrityPage />} />
                <Route path="/admin-tools" element={<AdminToolsOverview />} />
                <Route path="/vendorbenefitsmailer" element={<VendorBenefitsMailer />} />
                <Route path="/invite-manager" element={<InviteManager />} />
                <Route path="/waitlist-manager" element={<WaitlistManager />} />
                <Route path="/taper-tracker" element={<TaperTrackerRedirect />} />
              </Routes>
                    </main>
                  </>
                )}
              </>
            )
          } />
        </Routes>
      </div>
    </Router>
  )
}

function App() {
  return (
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  )
}

export default App